import {FC, useState} from 'react';
import {text} from '../../text';
import {hooks} from '../../hooks';
import {custom} from '../../custom';
import {svg} from '../../assets/svg';
import {theme} from '../../constants';
import {components} from '../../components';
import toast from 'react-hot-toast';
import CircularProgress from '@mui/material/CircularProgress'; // Ensure you have this import
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {changePassword} from '../../services/authService';
export const ChangePassword: FC = () => {
  const navigate = hooks.useAppNavigate();

  // State to manage password inputs and loading state
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChangePassword = async () => {
    setError('');
    if (newPassword !== newPasswordConfirmation) {
      setLoading(false);
      setError('New passwords do not match.');
      return;
    }
    try {
      setLoading(true);
      const response = await changePassword(
        password,
        newPassword,
        newPasswordConfirmation
      );
      // console.log(response);
      toast.success('Password changed successful');
      navigate('/home');
    } catch (error) {
      console.log(error);
      toast.error((error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header basket={true} line={true} navlink={true} />;
  };

  const renderFooter = (): JSX.Element => {
    return (
      <components.Footer
        logo={true}
        copyright={true}
        links={[
          {label: 'Home', path: '/Home'},
          {label: 'About', path: '/About'},
          {label: 'Services', path: '/Services'},
          {label: 'Contact', path: '/Contact'},
        ]}
      />
    );
  };

  const renderContent = () => {
    return (
      <div style={{marginTop: 230}}>
        <main
          className='container'
          style={{
            padding: '50px 20px 20px 20px',
            marginTop: 10,
            textAlign: 'center',
            border: '1px solid #E8EFF4',
            borderRadius: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0,0,0)',
          }}
        >
          <div className='d-flex'>
            <ArrowBackIosIcon
              onClick={() => {
                navigate(-1);
              }}
            />
            <text.T16
              style={{
                marginBottom: 40,
                color: theme.colors.textColor,
              }}
            >
              Enter your old password and set a new password.
            </text.T16>
          </div>

          <custom.InputField
            clickable={true}
            label='Old Password'
            placeholder='••••••••'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={<svg.EyeOffSvg />}
            containerStyle={{marginBottom: 20}}
          />

          <custom.InputField
            clickable={true}
            label='New Password'
            placeholder='••••••••'
            type='password'
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            icon={<svg.EyeOffSvg />}
            containerStyle={{marginBottom: 20}}
          />

          <custom.InputField
            clickable={true}
            label='Confirm New Password'
            placeholder='••••••••'
            type='password'
            value={newPasswordConfirmation}
            onChange={(e) => setNewPasswordConfirmation(e.target.value)}
            icon={<svg.EyeOffSvg />}
            containerStyle={{marginBottom: 20}}
          />

          {error && <div style={{color: 'red'}}>{error}</div>}
          {loading ? (
            <div style={{textAlign: 'center', marginTop: '20px'}}>
              <CircularProgress color='inherit' />
            </div>
          ) : (
            <components.Button
              title='Change Password'
              onClick={handleChangePassword}
              style={{
                marginBottom: 20,
                backgroundColor: theme.colors.mainColor,
              }}
            />
          )}
        </main>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          justifyContent: 'center',
        }}
      >
        {renderHeader()}
        {renderContent()}
        {renderFooter()}
      </div>
    </>
  );
};
